<template>
    <!--<div class="target-history">-->
        <!--<div class="card card-custom gutter-b">
            <div class="card-header align-items-center px-4">
                <div class="text-left flex-grow-1"></div>
                <div class="text-center flex-grow-1">
                    <div class="text-dark-75 font-weight-bold h3">Historial de Participación para deportistas</div>
                    <div>
						<span class="font-weight-bold text-muted font-size-sm">Ingrese el número de documento</span>
					</div>
                </div>
                <div class="text-right flex-grow-1"></div>
            </div>
            <div class="card-body">
                d
            </div>
        </div>-->
        <div class="d-flex flex-row">
            <div class="flex-row-auto offcanvas-mobile w-250px w-xxl-350px">
                <el-affix :offset="120">
                <div class="card card-custom">
                    
                    <div class="card-body py-4" v-if="historydata.athlete!=null">
                        <div class="text-center mt-10 mb-10 border-bottom d-none" v-if="nrodocument!=null">
							<div class="symbol symbol-60 symbol-circle symbol-xl-90">
								<div class="ok symbol-label" style="background-image:url('https://preview.keenthemes.com/metronic/theme/html/demo2/dist/assets/media/users/300_21.jpg')"></div>
								<i class="symbol-badge symbol-badge-bottom bg-success"></i>
							</div>
							<h4 class="font-weight-bold my-2">{{historydata.athlete.firstname}}</h4>
							<div class="text-muted mb-2">{{historydata.athlete.lastname}} {{historydata.athlete.surname}}</div>
							<span class="label label-light-warning label-inline font-weight-bold label-lg mb-5">Active</span>
						</div>

						<div class="form-group row my-2">
						    <label class="col-4 col-form-label">Documento:</label>
							<div class="col-8">
								<span class="form-control-plaintext font-weight-bolder">{{historydata.athlete.docnumber}}</span>
							</div>
						</div>

						<div class="form-group row my-2">
						    <label class="col-4 col-form-label">Sexo:</label>
							<div class="col-8">
								<span class="form-control-plaintext font-weight-bolder">{{historydata.athlete.gender}}</span>
							</div>
						</div>

                        <div class="form-group row my-2">
						    <label class="col-4 col-form-label">Nacimiento:</label>
							<div class="col-8">
								<span class="form-control-plaintext font-weight-bolder">{{historydata.athlete.birthday}}</span>
							</div>
						</div>

						<div class="form-group row my-2 d-none">
							<label class="col-4 col-form-label">Revenue:</label>
							<div class="col-8">
								<span class="form-control-plaintext">
								<span class="font-weight-bolder">345,000M</span>&nbsp; 
								<span class="label label-inline label-danger label-bold">Q4, 2019</span></span>
							</div>
						</div>

						<div class="form-group row my-2">
							<label class="col-4 col-form-label">Teléfono:</label>
							<div class="col-8">
								<span class="form-control-plaintext font-weight-bolder">{{historydata.athlete.phone1}}</span>
							</div>
						</div>

                        <div class="form-group row my-2">
							<label class="col-4 col-form-label">Celular:</label>
							<div class="col-8">
								<span class="form-control-plaintext font-weight-bolder">{{historydata.athlete.phone2}}</span>
							</div>
						</div>

						<div class="form-group row my-2">
							<label class="col-4 col-form-label">Email 1:</label>
							<div class="col-8">
								<span class="form-control-plaintext font-weight-bolder">
									<a href="#">{{historydata.athlete.email1}}</a>
								</span>
							</div>
						</div>

                        <div class="form-group row my-2">
							<label class="col-4 col-form-label">Email 2:</label>
							<div class="col-8">
								<span class="form-control-plaintext font-weight-bolder">
									<a href="#">{{historydata.athlete.email2}}</a>
								</span>
							</div>
						</div>

						<div class="form-group row my-2">
							<label class="col-4 col-form-label">Dirección:</label>
							<div class="col-8">
								<span class="form-control-plaintext font-weight-bolder">
									<a href="#">{{historydata.athlete.address}}</a>
								</span>
							</div>
						</div>

					</div>
                    <el-empty v-else :image-size="235"></el-empty>
                </div>
                </el-affix>
            </div>

            <div class="flex-row-fluid ml-lg-8">
                <div class="d-flex flex-column flex-grow-1">
                    <div class="card card-custom gutter-b mb-5">
                        <div class="card-body d-flex align-items-center justify-content-between flex-wrap py-3">
                            <h3 class="font-weight-bold mb-0 mr-5 text-success">Historial de participación</h3>
                            <div class="d-flex align-items-center mr-2 py-2">
                                <el-input placeholder="# documento" v-model="nrodocument" clearable maxlength="11" @keypress.enter="searchHistory"></el-input>
                                <div class="btn mx-4 btn-success w-50" @click="searchHistory"><i class="el-icon-search"></i> Buscar</div>
                            </div>
                        </div>
                    </div>

                    <div class="card card-custom">
                        <div class="card-header">
                            <div class="card-title">
								<h3 class="card-label">Resumen de Participación 
								<span class="d-block text-muted pt-2 font-size-sm"></span></h3>
							</div>
                        </div>
                        <div class="card-body">
                            <el-timeline v-if="historydata.timeline.length>0">
                                
                                <el-timeline-item v-for="(item, index) in historydata.timeline" :key="index" :timestamp="'Periodo: ' + item.periodo" :color="item.color" type="success" placement="top">
                                    <el-card v-for="(card, y) in item.data" :key="y">
                                        <h4>{{card.event}}</h4>
                                        <span class="label font-weight-bold label-lg  label-light-success label-inline">{{card.sport}}</span> / {{card.funcname}}
                                        <div class="pruebas" v-if="card.test.length>0">
                                            <h5>Pruebas</h5>
                                            <ul>
                                                <li v-for="(prueba, z) in card.test" :key="z">{{prueba.name}}</li>
                                            </ul>
                                        </div>
                                    </el-card>
                                </el-timeline-item>
                            </el-timeline>
                            <el-empty v-else :image-size="235"></el-empty>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <!--</div>-->
</template>
<script>
import { ATHLETE_HISTORY } from "@/store/acreditation.module";
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/store/htmlclass.module.js";

export default {
    name: 'athletehistory',
    data: () => ({
        nrodocument: null,
        historydata: {
            athlete: {
                docnumber: '',
                gender: '',
                birthday: '',
                firstname: '',
                lastname: '',
                surname: '',
                phone1: '',
                phone2: '',
                email1: '',
                email2: '',
                address: ''
            },
            timeline: []
        }
    }),
    methods: {
        searchHistory(){
            if(this.nrodocument == null || this.nrodocument == '')
                return this.$notify.warning({title: 'Campos vacios', message: 'Falta ingresar nro. de documento.'});

            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                this.$store.dispatch(ATHLETE_HISTORY, this.nrodocument)
                .then((data) => {
                    this.historydata = data;
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                })
                .catch((err) => {
                    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                    this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                        type: 'error',
                        confirmButtonText: 'Entendido',
                        callback: action => {code.Manager(err.status, 'athlete');}
                    });
                })
            } catch (error) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                alert(error);
            }
        }

    }
}
</script>
<style>
.ok.symbol-label{height: 250px;;}
</style>